module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/babel-runtime/core-js/object/create.js
// module id = 557
// module chunks = 0